import { render, staticRenderFns } from "./shuxing.vue?vue&type=template&id=65a02040&scoped=true&"
import script from "./shuxing.vue?vue&type=script&lang=ts&"
export * from "./shuxing.vue?vue&type=script&lang=ts&"
import style0 from "./shuxing.vue?vue&type=style&index=0&id=65a02040&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a02040",
  null
  
)

export default component.exports